
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <CardTitle className="text-6xl font-bold text-gray-400">404</CardTitle>
          <h2 className="text-2xl font-semibold">Страница не найдена</h2>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-gray-600">
            Запрашиваемая страница не существует или была удалена.
          </p>
          <Button asChild>
            <Link to="/">Вернуться на главную</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
